import React from "react";
import { useHistory } from "react-router-dom";

const NavProfileListComponent = ({ list, handleShowSideMenu }) => {
  const history = useHistory();
  return (
    <>
      {list.map((item, index) => {
        if (item.href) {
          return (
            <a
              key={index}
              href={item.href}
              target="_blank"
              className={`dropdown-item${item.borderTop ? "pt-4 border-top" : ""}`}
              onClick={() => {
                handleShowSideMenu();
              }}
            >
              {item.icon}
              <span>{item.title}</span>
            </a>
          );
        } else {
          return (
            <button
              key={index}
              onClick={
                item.handleLogout ? item.handleLogout : () => history.push(item.path)
              }
              className={`dropdown-item${item.handleLogout ? " text-danger" : ""} ${
                item.borderTop ? "pt-4 border-top" : ""
              }`}
            >
              {item.icon}
              <span>{item.title}</span>
              {item.notification && <span>{item.notification}</span>}
            </button>
          );
        }
      })}
    </>
  );
};

export default NavProfileListComponent;
